module.exports = __webpack_public_path__ + "img/3.4eb2b085.png";